import { render, staticRenderFns } from "./UserAddModal.vue?vue&type=template&id=0c12bfd8&scoped=true&"
import script from "./UserAddModal.vue?vue&type=script&lang=ts&"
export * from "./UserAddModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserAddModal.vue?vue&type=style&index=0&id=0c12bfd8&scoped=true&lang=css&"
import style1 from "./UserAddModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c12bfd8",
  null
  
)

export default component.exports